<template>
		<div class="view-modal-body">
				<ul class="header">
					<li
						v-for="item in urlMaps"
						:key="item.url"
						@click="componentSwitch(item.url)"
						:class="{ active : active === item.url }"
					>{{item.name}}</li>
					<span @click="closeModal"><i class="el-icon-close"/></span>
				</ul>
		<div class="container">
			<GoodsInfo :goodsId='goodsId' v-if="active === urlMaps[0].url"/>
			<AttrInfo :productId='productId' :goodsId='goodsId' v-if="active === urlMaps[1].url" @cancel="closeModal"/>
			<StoreAttr v-if="active === urlMaps[2].url" :productId='productId' @cancel="closeModal"/>
			<!-- <Delivery :productId='productId' v-if="active === urlMaps[3].url" @cancel="closeModal"/> -->
			<!-- <Freight :productId='productId' v-if="active === urlMaps[3].url" @cancel="closeModal"/> -->
			<ShowImg :productId='productId' :goodsId='goodsId' v-if="active === urlMaps[3].url" @cancel="closeModal" ref="showImgRef"/>
		</div>

		</div>
</template>

<script>
import GoodsInfo from '@/components/storeSetting/saleableGoods/viewModalCom/GoodsInfo.vue'
import AttrInfo from '@/components/storeSetting/saleableGoods/viewModalCom/Attribute.vue'
import StoreAttr from '@/components/storeSetting/saleableGoods/viewModalCom/StoreAttr.vue'
// import Freight from '@/components/storeSetting/saleableGoods/viewModalCom/Freight.vue'
// import Delivery from '@/components/storeSetting/saleableGoods/viewModalCom/Delivery.vue'
import ShowImg from '@/components/storeSetting/saleableGoods/viewModalCom/ShowImg.vue'
export default {
	name: 'viewModal',
	components: {
		GoodsInfo,
		AttrInfo,
		StoreAttr,
		// Delivery,
		ShowImg
		// Freight
	},
	props: {
		productId: String,
		showBtn: Boolean,
		goodsId: String
	},
	data () {
		return {
			urlMaps: [
				{ name: '商品信息', url: 'goodsInfo' },
				{ name: '属性信息', url: 'attrInfo' },
				{ name: '店内属性', url: 'storeAttr' },
				// { name: '配送范围', url: 'delivery' },
				// { name: '商品运费', url: 'freight' },
				{ name: '展示图设置', url: 'showImg' }
			],
			active: 'goodsInfo'
		}
	},
	methods: {
		closeModal () {
			this.$emit('update:visible', false)
			this.$emit('isClose', false)
		},
		componentSwitch (url) {
			this.active = url
		},
		returnChange () {
			if (this.$refs.showImgRef) {
				return this.$refs.showImgRef.returnChange()
			} else {
				return false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.view-modal-body {
	display flex
	flex: 1
	flex-direction column
	.header {
		border-bottom: 1px solid #dce2fd;
		height:48px;
		line-height: 48px;
		font-size: 16px;
		box-sizing border-box
		li {
			margin-right 40px
			cursor pointer
			height: 100%
			box-sizing:border-box
			float left
			&.active {
				border-bottom: 3px solid var(--fx-primary-color);
				font-weight: bold
			}
		}
		span {
			cursor pointer
			float right
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 21px;
			font-weight: bold;
			margin-top 12px
			.el-icon-close{
				color:#fff
			}
		}
	}
	.container {
		height: 550px
		display flex
	}
}
</style>
